import React from 'react'
import { DrawerWrapper } from './styles'
import DrawerHeader from './Header'
import DrawerRoot from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import styled from 'styled-components'

const Style = styled.div`
  .EZDrawer__overlay {
    z-index: 1031 !important;
  }

  .EZDrawer__container {
    z-index: 1032 !important;

    .react-select__menu-portal {
      z-index: 9999 !important;
    }
  }
`

const DrawerContext = React.createContext(undefined)

/**
 * DrawerProvider component that provides context for drawer state and actions.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to be rendered within the provider.
 * @param {boolean} props.open - A boolean indicating whether the drawer is open.
 * @param {() => void} props.onClose - A function to be called when the drawer needs to be closed.
 * @returns {JSX.Element} The DrawerProvider component.
 */
const DrawerProvider = ({ children, open, onClose }) => {
  return (
    <DrawerContext.Provider value={{ open, onClose }}>
      <Style>{children}</Style>
    </DrawerContext.Provider>
  )
}
/**
 * @returns {open: boolean,onClose: () => void}
 */
/**
 * Custom hook to access the Drawer context.
 *
 * @returns {{ open: boolean, onClose: () => void }} The context value of the Drawer.
 * @throws {Error} If the hook is used outside of a DrawerProvider.
 */
export const useDrawer = () => {
  const context = React.useContext(DrawerContext)
  if (context === undefined) {
    throw new Error('useDrawer must be used within a DrawerProvider')
  }
  return context
}

export const Drawer = ({ open, onClose, children }) => {
  return (
    <DrawerProvider onClose={onClose} open={open}>
      <DrawerRoot
        open={open}
        onClose={onClose}
        direction="right"
        style={{
          width: '328px',
        }}
      >
        <DrawerWrapper>{children}</DrawerWrapper>
      </DrawerRoot>
    </DrawerProvider>
  )
}

Drawer.Header = DrawerHeader
Drawer.Divider = () => <div className="drawer-divider" />
